import { render, staticRenderFns } from "./movie-list.vue?vue&type=template&id=601d9f46&scoped=true"
import script from "./movie-list.vue?vue&type=script&lang=js"
export * from "./movie-list.vue?vue&type=script&lang=js"
import style0 from "./movie-list.vue?vue&type=style&index=0&id=601d9f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d9f46",
  null
  
)

export default component.exports